import React from 'react'
import { Row, Col } from 'react-bootstrap'
import LearningResourcesFilters from '../filters'
import LearningResourcesListPaginated from '../paginated-list'
import LearningResourceCard from '../card'

const LearningResourcesManagerMobile = () => {
    return (
        <Row>
            <Col>
                <Row>
                    <Col className='text-center'>
                        <h2>Learning Resources</h2>
                    </Col>
                </Row>
                
                <div style={{ paddingLeft: '10px', paddingRight: '10px'}}>
                    <LearningResourcesFilters />
                </div>
                
                <LearningResourcesListPaginated itemComponent={LearningResourceCard} />
            </Col>
        </Row>
    )
}

export default LearningResourcesManagerMobile